<template>
<div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
        <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
      <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
    </v-snackbar>
    <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    
    <template>
      <v-toolbar flat>
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-format-list-bulleted</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex lg3>
            <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
          </v-flex>
        <!--v-dialog-->
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn 
              
                v-show=insertact
                outlined
                rounded
                small
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
                >
                Add Rest Api
                <v-icon class="ml-2">mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
              <v-card-text style="max-height: 400px; overflow-y: auto;" class="overflow-card">
                <v-form class="ml-2" ref="form" lazy-validation>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field dense outlined v-model="inputItem.apiname" :rules="apinamerules" label="API Name"></v-text-field>
                      </v-col> 
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field dense outlined v-model="inputItem.baseurl" :rules="baseurlrules" label="Base URL"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field dense outlined v-model="inputItem.token" :rules="tokenrules" label="Token"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <v-select dense outlined :items="method" v-model="inputItem.method" :rules="methodrules" label="Method"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field dense outlined v-model="inputItem.endpoint" :rules="endpoinrules" label="Endpoint"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field dense outlined v-model="inputItem.parameters" :rules="paameterrules" label="Parameters"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field dense outlined v-model="inputItem.directory" :rules="directoryrules" label="Output Directory"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field dense outlined v-model="inputItem.outputfilename" :rules="outputfilenamerules" label="Output Filename"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions class="py-3">
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" width="330px">
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar>
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text> 

              <v-divider class="mt-4" style=""></v-divider>

              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK 
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-toolbar>
    </template>
    <v-data-table
      :headers="headers"
      :items="restapi"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :search="search"
      item-key="baseurl"
      show-expand
      class="table-user ml-6 mr-6 mt-4 rounded-lg"
      :loading="tableLoading"
      loading-text="Loading data..."
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mr-2" small v-show=updateact  @click="editItem(item.SEQ_ID)">
            mdi-pencil
          </v-icon>
          <v-icon small v-show=deleteact @click="deleteItem(item.SEQ_ID)">
            mdi-delete
          </v-icon>
        </template>
        
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" elevation="0" class="pa-3 elevation-0">
          <p> Auth token: {{ item.AUTH_TOKEN }} </p>
          <p> Method : {{ item.METHOD }} </p>
          <p> Endpoint :{{ item.ENDPOINT }} </p>
        </td>
      </template>
    </v-data-table>
    <Notification  ref="alert"></Notification>
</div>
</template>


<script>
import axios from "axios";
import Notification from  '@/components/Notification';
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",
      
      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      apinamerules: [
          v => !!v || 'Api Name is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Api Name can only contain letters, numbers, spaces and special characters (.@_-)',
        ],
        
      baseurlrules: [
          v => !!v || 'Base URL is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Base URL can only contain letters, numbers, spaces and special characters (.@_-)',
        ],
        
      tokenrules: [
          v => !!v || 'Token is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Token can only contain letters, numbers, spaces and special characters (.@_-)',
        ],
      methodrules: [
          v => !!v || 'Method is required',
        ],
        
      endpoinrules: [
          v => !!v || 'Endpoint is required',
          // v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Endpoint can only contain letters, numbers, spaces and special characters (.@_-)',

        ],
        
      paameterrules: [
          v => !!v || 'Parameter is required',
          v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Parameter can only contain letters, numbers, spaces and special characters (.@_-)',

        ],
        
      directoryrules: [
          v => !!v || 'Output Directory Filename is required',
          // v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Output Directory Filename can only contain letters, numbers, spaces and special characters (.@_-)',

        ],
      outputfilenamerules: [
          v => !!v || 'Output Filename is required',
          // v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Output Filename can only contain letters, numbers, spaces and special characters (.@_-)',

        ],
      dialog: false,
      dialogDelete: false,
        method: ['POST', 'GET', 'PUT', 'DELETE'],
        expanded: [],
        singleExpand: false,
        search:'',
        headers: [
        {
          text: 'Base URL',
          align: 'start',
          sortable: false,
          value: 'BASE_URL',
        },
        { text: 'Created Date', value: 'SYS_CRE_DATE' },
        { text: 'Created By', value: 'SYS_CRE_BY' },
        { text: 'Update Date', value: 'SYS_UPT_DATE' },
        { text: 'Update By', value: 'SYS_UPT_BY' },
        { text: 'Actions', value: 'actions' },
        ],
        restapi:[],
        id_rest_api:"",
        inputItem: {
        },
        defaultItem: {
        },
    }),
    computed: {
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Youtube Rest API' : 'Update Youtube Rest API'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        this.tableLoading = true;
        axios.get("ytube-rest-api",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            console.log(response.data);
            this.restapi = response.data;
            console.log()
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      deleteItem (item) {
        // alert(item);
        this.id_rest_api = item
        this.editedIndex = this.restapi.indexOf(item)
        this.inputItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.restapi.splice(this.editedIndex, 1)
        axios({
          method: "delete",
          url: "/ytube-rest-api/delete",
          data: {
            id: this.id_rest_api
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
          var status = response.data.status
          var messages = response.data.msg
          if(status == 200){
            this.initialize ();
            this.alertSuccess = true;
            this.alert_err_attention =  messages;
            this.closeDelete()
          }else{
              this.alertFailed = true;
              this.alert_err_attention =  messages;
          } 
        })
        .catch(function (error) {
          // handle error
          this.alertFailed = true;
          this.alert_err_attention =  'Delete Failed '+error;
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        this.editedIndex = 1
        this.inputItem = Object.assign({}, item)
        this.dialog = true
        axios({
          method: "put",
          url: "/ytube-rest-api-id",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            const dat = response.data[0];
            this.id_rest_api = dat.SEQ_ID;
            // alert(dat.API_NAME);
            this.inputItem = {
              apiname:dat.API_NAME,
              baseurl:dat.BASE_URL,
              token:dat.AUTH_TOKEN,
              method:dat.METHOD,
              endpoint:dat.ENDPOINT,
              parameters:dat.REQ_PARAMS,
              directory:dat.OUTPUT_DIR,
              outputfilename:dat.OUTPUT_FILENAME,
              
            }
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
      },
      save () {
        const isValid = this.$refs.form.validate();
        if (isValid) {
          this.btnload = true
              if (this.editedIndex > -1) { 
                axios.put("/ytube-rest-api/update", 
                  {
                    seq_id:this.id_rest_api,
                    api_name:this.inputItem.apiname,
                    base_url:this.inputItem.baseurl,
                    auth_token:this.inputItem.token,
                    method:this.inputItem.method,
                    endpoint:this.inputItem.endpoint,
                    req_params:this.inputItem.parameters,
                    output_dir:this.inputItem.directory,
                    output_filename:this.inputItem.outputfilename,
                  },
                  
                  {headers:{'auth-token':localStorage.getItem('token_app')}},
                  {dataType: 'json'}
                  )
                .then((response) => {
                    var status = response.data.status
                    var messages = response.data.msg
                    if(status == 200){
                      this.initialize();
                      this.$router.push('/restapi');
                      this.alertSuccess = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                      this.close()
                    }else{
                        this.alertFailed = true;
                        this.alert_err_attention =  messages;
                        this.btnload = false
                    } 
                  })
                .catch((e) => {
                      switch (e.response.status) {
                          case 404:
                                this.$refs.alert.error_login(404);
                              break;
                          case 403:
                                this.$refs.alert.error_login(403);
                              break;
                          case 400:
                                this.alertFailed = true;
                                this.alert_err_attention =  e.response.data.msg;
                              break;
                          default:
                              console.log('some other error');  // end up here all the time
                              break;
                          }
                  this.errors=e.response.data.msg;
                });
                Object.assign(this.restapi[this.editedIndex], this.inputItem)
              } 
              else {
                axios.post("/ytube-rest-api/insert", 
                  {
                    api_name:this.inputItem.apiname,
                    base_url:this.inputItem.baseurl,
                    auth_token:this.inputItem.token,
                    method:this.inputItem.method,
                    endpoint:this.inputItem.endpoint,
                    req_params:this.inputItem.parameters,
                    output_dir:this.inputItem.directory,
                    output_filename:this.inputItem.outputfilename,
                    
                  },
                  { headers:{'auth-token':localStorage.getItem('token_app')}},
                  {dataType: 'json'}
                  )
                .then((response) => {
                    var status = response.data.status
                    var messages = response.data.msg
                    if(status == 200){
                      this.initialize();
                      this.$router.push('/restapi');
                      this.alertSuccess = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                      this.close()
                    }else{
                        this.alertFailed = true;
                        this.alert_err_attention =  messages;
                        this.btnload = false
                    } 
                  })
                .catch((e) => {
                      switch (e.response.status) {
                          case 404:
                                this.$refs.alert.error_login(404);
                              break;
                          case 403:
                                this.$refs.alert.error_login(403);
                              break;
                          case 400:
                                this.alertFailed = true;
                                this.alert_err_attention =  e.response.data.msg;
                              break;
                          default:
                              console.log('some other error');  // end up here all the time
                              this.btnload = false
                              break;
                          }
                  this.errors=e.response.data.msg;
                });
                
                this.restapi.push(this.inputItem)


              } 
              this.close()
        }
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.inputItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    },
  }
</script>

<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>